import React from "react";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import queryString from "query-string";
import c from "classnames";

import { ImageBlock, ContentBlock, WindowBlock, DateBlock, PreviewBlock } from "../blocks";

import stock1 from "./img/stock1.jpg";

const Multiple = ({ wpRoute, title, pagination = true }) => {
  const location = window.location;

  const { posts } = wpRoute;

  return (
    <>
      <WindowBlock>
        <ImageBlock src={stock1} style={{ height: "350px" }}>
          <div className="text-center text-white">
            <h1>{title}</h1>
          </div>
        </ImageBlock>
      </WindowBlock>
      <ContentBlock>
        {posts.length === 0 ? (
          <>
            <h1>Keine Ergebnisse</h1>
            <div className="pt-3">
              <span>Es konnten keine Ergebnisse für die Suchanfrage gefunden werden.</span>
            </div>
          </>
        ) : (
          <div className="row">
            {posts.map((post, index) => (
              <div className="col-12 col-md-6 col-lg-4" key={index}>
                <PreviewBlock postType={post["post_type"]} id={post["ID"]} />
              </div>
            ))}
            {pagination && (
              <div className="col-12 pagination-bar pt-5">
                <ReactPaginate
                  previousLabel={<FontAwesomeIcon icon="chevron-left" fixedWidth />}
                  nextLabel={<FontAwesomeIcon icon="chevron-right" fixedWidth />}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={wpRoute["max_num_pages"]}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={({ selected }) => {
                    window.location.href = `${window.location.pathname}?${queryString.stringify({
                      ...wpRoute.query,
                      paged: selected + 1,
                    })}`;
                  }}
                  containerClassName={"pagination d-flex justify-content-center"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                  forcePage={parseInt(wpRoute.query.paged) - 1 || 0}
                />
              </div>
            )}
          </div>
        )}
      </ContentBlock>
    </>
  );
};

export default Multiple;
